"use client";
import logoSvg from "@/asset/icons/klarda-media-logo.svg";
import { motion } from "framer-motion";
import Image from "next/image";
import { Button } from "./ui/button";
import bgHero1 from "@/asset/images/main-bg.png";
import bgHero2 from "@/asset/images/bg-hero-2.png";
import bgHero1Mobile from "@/asset/images/mobile/main-bg.png";
import bgHero2Mobile from "@/asset/images/mobile/hero-bg-2.png";
import bgHero1Tablet from "@/asset/images/tablet/main-bg.png";
import bgHero2Tablet from "@/asset/images/tablet/hero-bg-2.png";
import { useEffect, useState } from "react";
import Link from "next/link";

export default function HomeSection() {
  // Add state to control animation
  const [animationReady, setAnimationReady] = useState(false);
  // Add state to track if we're on mobile
  const [windowWidth, setWindowWidth] = useState(0);

  // This ensures animations only start after component is fully mounted
  useEffect(() => {
    // Small delay to ensure component is properly mounted in the DOM
    const timer = setTimeout(() => {
      setAnimationReady(true);
    }, 100);

    // Initial check for mobile
    setWindowWidth(window.innerWidth);

    // Add window resize listener
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isMobile = windowWidth < 768;
  const isTablet = windowWidth >= 768 && windowWidth < 1024;

  return (
    <>
      <div
        id='home'
        className='min-h-[700px] md:min-h-[calc(100vh-200px)] lg:min-h-[calc(100vh+200px)] w-full relative overflow-hidden flex items-center bg-no-repeat bg-bottom object-contain bg-cover'
        style={{
          backgroundImage: `url(${
            isMobile
              ? bgHero1Mobile.src
              : isTablet
              ? bgHero1Tablet.src
              : bgHero1.src
          })`,
        }}>
        <div className='absolute inset-0'>
          {/* Background Hero - appears after logo moves up */}
          <motion.div
            className='absolute inset-0 z-0 block'
            initial={{ opacity: 0 }}
            animate={
              animationReady
                ? { opacity: 1, y: isMobile ? 20 : 0 } // Điều chỉnh từ 50 xuống 20
                : { opacity: 0 }
            }
            transition={{
              duration: 1.2,
              ease: "easeOut",
              delay: 1.7, // Delay until after logo has moved up
            }}>
            <Image
              src={isMobile ? bgHero2Mobile : bgHero2}
              alt='Background'
              layout='fill'
              objectFit='contain'
              priority
            />
          </motion.div>

          <div className='flex flex-col items-center justify-center h-full px-4 text-center relative z-20'>
            {/* Logo animation - appears first, then moves up */}
            {/* Logo animation */}
            <motion.div
              className='bg-white rounded-full flex items-center justify-center mb-4'
              initial={{ scale: 0.9, y: -40, opacity: 0 }} // Đã loại bỏ điều kiện isMobile
              animate={
                animationReady
                  ? {
                      scale: 1,
                      y: isMobile ? -80 : -125,
                      opacity: 1,
                    }
                  : { scale: 0.9, y: -40, opacity: 0 }
              }
              transition={{
                opacity: { duration: 0.8 },
                scale: { duration: 0.8 },
                y: {
                  delay: 0.8,
                  duration: 1.2,
                  ease: "easeInOut",
                },
              }}>
              <Image
                src={logoSvg}
                alt='Klarda Media'
                width={1036}
                height={146}
                priority
              />
            </motion.div>

            {/* Text content - appears only after logo has moved up */}
            <motion.div
              initial={{ opacity: 0, y: isMobile ? -80 : -100 }}
              animate={
                animationReady
                  ? { opacity: 1, y: isMobile ? -80 : -100 } // Giữ nguyên giá trị y như initial
                  : { opacity: 0, y: isMobile ? -80 : -100 }
              }
              transition={{
                duration: 1,
                delay: 1.7,
                ease: "easeOut",
              }}>
              <h1 className='text-textColor text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold mb-6 md:mb-12 lg:mb-16'>
                Elevate Your Crypto Project
              </h1>
              <div className='flex flex-col sm:flex-row items-center justify-center gap-4'>
                <Link href='#about'>
                  <Button
                    size='lg'
                    style={{
                      background:
                        "linear-gradient(to right, #443DFF 0%, #9747FF 100%)",
                    }}
                    className='text-white hover:opacity-90 rounded-[15px] h-[52px] px-6 md:px-10 shadow-btn text-sm md:text-base lg:w-[204px] md:w-[184px] w-[136px]'>
                    Get Started
                  </Button>
                </Link>

                <Link href='/details'>
                  <Button
                    variant='outline'
                    size='lg'
                    className='hover:bg-white/90 rounded-[15px] h-[52px] px-6 md:px-10 border-[#0900F1] border-2 shadow-btn text-sm md:text-base lg:w-[204px] md:w-[184px] w-[136px]'>
                    Learn More
                  </Button>
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
}
